import LogRocket from 'logrocket';

let initialized = false;

export function initLogRocket(disabled) {
  if (!process.env.VUE_APP_LOG_ROCKET_APP_ID || disabled) {
    return;
  }

  if (initialized === true) {
    return;
  }

  if (process.env.NODE_ENV === 'production') {
    LogRocket.init(process.env.VUE_APP_LOG_ROCKET_APP_ID, {
      release: process.env.VUE_APP_GIT_RELEASE,
      console: true,
      network: false,
      dom: false,
      shouldCaptureIP: true,
    });
    initialized = true;
  }
}

export default LogRocket;
